<template>
    <div class="mt-1 app-left-margin app-right-margin w-100 " v-resize="onResize">
        <c-app-bar
            title          = "OUTBOX"
            :categories    = "[]"
            :enable-search = "false"
        >
            <template v-slot:search>
                <v-spacer />
            </template>
        </c-app-bar>

        <p-inc-outbox
            :search = "search"
            :height = "height"
        />
    </div>
</template>

<script>

import PIncOutbox from "@/modules/inc/outbox/components/private/PIncOutbox.vue";
import CAppBar    from "@/modules/core/components/app/CAppBar.vue";

export default {
    name: "MIncOutbox",

    components: {
        CAppBar,
        PIncOutbox,
    },

    data: () => ({
       entries: null,
        height: null,
        selected: null,
        mail: null,
        loading: false,
        search: null
    }),

    mounted() {
        this.onResize()
    },

    methods: {
        onResize() {
            this.height = window.innerHeight - 240;
        },

        onSearch (text) {
            this.search = text;
        }
    }
}
</script>

<style scoped>
</style>